/**
 * LegalPage — renders a legal document (markdown) as a public page.
 *
 * Content is imported with Vite's `?raw` suffix at the route level and passed in,
 * so this component stays document-agnostic.
 */

import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import { Button } from "@/components/ui/button"

interface LegalPageProps {
  title: string
  content: string
}

export function LegalPage({ title, content }: LegalPageProps) {
  const { t } = useTranslation()

  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="border-b border-border px-4 py-4">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <h1 className="text-foreground font-display font-bold text-xl">{title}</h1>
          <Button variant="ghost" asChild className="text-muted-foreground hover:text-foreground">
            <Link to="/">{t("legal.back")}</Link>
          </Button>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-8">
        <article className="prose prose-invert max-w-none prose-headings:font-display prose-a:text-primary">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
        </article>
      </div>
    </div>
  )
}
